import LocalizedStrings from 'react-localization';
import en from './locales/en.json';

export const LANGUAGES = ['en'];
export const Strings = new LocalizedStrings({en});
Strings.setLanguage('en');
